import { render, staticRenderFns } from "./CourseIndex.vue?vue&type=template&id=12018ace&scoped=true&"
import script from "./CourseIndex.vue?vue&type=script&lang=js&"
export * from "./CourseIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12018ace",
  null
  
)

export default component.exports